import ConnectionProfiling from "./ConnectionProfiling";

const DataSourcesInsights = () => {
  return <ConnectionProfiling />;
};

export default DataSourcesInsights;
